import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClash = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	stroke: "none",
	width: 24,
	height: 24,
	fill: "currentColor",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M 14 2 H 4 A 2 2 0 0 0 2 4 V 14 A 2 2 0 0 0 4 16 H 8 V 20 A 2 2 0 0 0 10 22 H 20 A 2 2 0 0 0 22 20 V 10 A 2 2 0 0 0 20 8 H 16 V 4 A 2 2 0 0 0 14 2 M 4 14 V 4 H 14 V 8 H 10 A 2 2 0 0 0 8 10 V 14 Z M 10 20 V 16 H 14 A 2 2 0 0 0 16 14 V 10 H 20 V 20 Z"
	})]
});
export default SvgClash;
